export const DEV_FLAG_KEY = "sup_activity_dev";
export const OUTBOX_PREFIX = "activity_outbox_v1:";
export const TAB_KEY = "activity_tab_v1";

export const FLUSH_MS = 15_000;
export const EARLY_FLUSH_AT = 150;
export const HIDDEN_BEACON_MIN_MS = 15_000;
export const BACKOFF_MS = [15_000, 30_000, 60_000, 120_000, 300_000];
export const REISSUE_MIN_MS = 10 * 60_000;
export const IMPERSONATION_FLUSH_WAIT_MS = 2_000;
export const ADMIN_RESOLVE_WAIT_MS = 3_000;

export const IDLE_ROTATE_MS = 30 * 60_000;
// Сервер принимает сеанс не старше 8 суток от его начала.
export const MAX_SESSION_AGE_MS = 24 * 60 * 60_000;

// Гостевые события уходят только из той же вкладки и только свежие: на общем
// компьютере чужие действия не должны попасть в журнал того, кто вошёл следом.
export const GUEST_MAX_AGE_MS = 2 * 60 * 60_000;
export const FOREIGN_OWNER_TTL_MS = 7 * 24 * 60 * 60_000;
export const ORPHAN_STALE_MS = 60_000;

export const SIGNED_CAP = 600;
export const GUEST_CAP = 300;
export const TOTAL_BYTES_CAP = 1_000_000;
export const BATCH_EVENTS = 200;
export const BATCH_BYTES = 57 * 1024;
export const BODY_MAX_BYTES = 60 * 1024;
export const EVENT_MAX_BYTES = 3_900;

export const isProduction = (): boolean => process.env.NODE_ENV === "production";

/** В разработке журнал молчит, пока его не включили руками. */
export const isEnabled = (): boolean => {
    if (isProduction()) return true;
    try {
        return localStorage.getItem(DEV_FLAG_KEY) === "1";
    } catch {
        return false;
    }
};
